import React from "react";
import { useFileDispatch } from "../context/FileContext";

const Statistics = () => {
  const [audioFile, textFile, , , , statistics] = useFileDispatch();

  const displayStats = () => {
    const stats = [];
    for (const [key, value] of Object.entries(statistics)) {
      stats.push(
        <li style={{ listStyleType: "format" }} className=" mt-4">
          {key === "process_time" && (
            <>
              <strong className="">{"Total audio length:"}</strong>
              <span className=" ml-2">{value + " "}sec</span>
            </>
          )}
          {key === "word_count" && (
            <>
              <strong>{"Total word count:"}</strong>
              <span className=" ml-2">{value + " "}words</span>
            </>
          )}
          {key === "coverage" && (
            <>
              <strong>{"Total coverage:"}</strong>
              <span className=" ml-2">{value * 100 + " "}%</span>
            </>
          )}
        </li>
      );
    }

    return stats;
  };

  return (
    statistics && (
      <div className=" border border-black rounded-md p-4 mb-10 bg-white shadow-xl relative">
        <h1 className=" text-xl font-semibold text-[#07074D]">Statistics</h1>

        <hr />

        <div className=" flex items-baseline gap-2 mt-2">
          <h1 className=" text-green-700 font-semibold">Files processed:</h1>
          <p>{typeof audioFile === "string" ? audioFile : audioFile.name}</p>
          <p>{typeof textFile === "string" ? textFile : textFile.name}</p>
        </div>

        <div>
          <ul className=" px-4">{displayStats()}</ul>
        </div>
      </div>
    )
  );
};

export default Statistics;
